import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  addContentToFollowings,
  removeContentToFollowings,
  getFollowings,
  addMultiple,
} from './thunks';
import { FollowingsState } from './types';

export const name = 'Followings';

const initialState: FollowingsState = {
  data: JSON.parse(localStorage.getItem('followings') || '[]'),
  flowingStatus: 'idle',
  addMultiple: {
    status: 'idle',
  },
};

export const addContentToFollowingsAsync = createAsyncThunk(
  name + '/addContentToFollowings',
  addContentToFollowings
);
export const removeContentToFollowingsAsync = createAsyncThunk(
  name + '/removeContentToFollowings',
  removeContentToFollowings
);

export const getFollowingsAsync = createAsyncThunk(
  name + '/getFollowings',
  getFollowings
);

export const addMultipleAsync = createAsyncThunk(
  name + '/addMultiple',
  addMultiple
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearaddContentToFollowingsStatus: (state) => {
      state.flowingStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addContentToFollowingsAsync.pending, (state) => {
        state.flowingStatus = 'loading';
      })
      .addCase(addContentToFollowingsAsync.fulfilled, (state) => {
        state.flowingStatus = 'idle';
      })
      .addCase(addContentToFollowingsAsync.rejected, (state) => {
        state.flowingStatus = 'failed';
      })
      .addCase(removeContentToFollowingsAsync.pending, (state) => {
        state.flowingStatus = 'loading';
      })
      .addCase(removeContentToFollowingsAsync.fulfilled, (state) => {
        state.flowingStatus = 'idle';
      })
      .addCase(removeContentToFollowingsAsync.rejected, (state) => {
        state.flowingStatus = 'failed';
      })
      .addCase(getFollowingsAsync.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addCase(addMultipleAsync.pending, (state) => {
        state.addMultiple.status = 'loading';
      })
      .addCase(addMultipleAsync.fulfilled, (state) => {
        state.addMultiple.status = 'idle';
      })
      .addCase(addMultipleAsync.rejected, (state) => {
        state.addMultiple.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
